<template>
  <div>
    <div class="time-off-request-balance">
      <div>
        <div class="avatar">
          <img
            v-if="memberAvatar"
            class="avatar-img"
            :src="memberAvatar"
            alt="avatar"
          />
          <div class="user-name">{{ memberName }}</div>
        </div>
        <div
          v-if="!showNextYearBalance"
          class="standard-balance"
        >
          <div class="main-balances">
            <div
              v-if="policyName"
              class="title"
            >
              <strong>{{ `${policyName} ${startAtYear}` }}</strong>
            </div>
            <div
              v-if="currentBalance"
              class="balance-info"
            >
              <div class="balance-label">Current balance</div>
              <div class="balance-value">
                {{ currentBalance }}
              </div>
            </div>
            <div class="balance-info">
              <div class="balance-label">
                Holiday hours (paid)
                <i class="hi hi-gift hi-16 text-blue"></i>
              </div>
              <div class="balance-value">{{ holidayHours }}</div>
            </div>
            <div class="balance-info">
              <div class="balance-label">Hours used {{ hoursUsedMessage }}</div>
              <div class="balance-value">{{ hoursUsed }}</div>
            </div>
            <div
              v-if="pendingApproval"
              class="balance-info"
            >
              <div class="balance-label">Other pending approval</div>
              <div class="balance-value">{{ pendingApproval }}</div>
            </div>
          </div>
          <div
            v-if="remainingBalance"
            class="remaining-balance"
          >
            <div class="balance-info">
              <div class="balance-label">Remaining balance</div>
              <div class="balance-value">
                <strong>{{ remainingBalance }}</strong>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="showNextYearBalance"
          class="next-year-stardard-balances"
        >
          <div class="content">
            <div class="next-year-main-balances start">
              <div
                v-if="showCurrentYearBalance"
                class="title cursor-pointer"
                @click="hideCurrentYearBalance(false)"
              >
                <i class="chevron fa fa-chevron-down"></i>
                <strong>{{ `${policyName} ${startAtYear}` }}</strong>
              </div>
              <div
                v-else
                class="title cursor-pointer"
                @click="hideCurrentYearBalance(true)"
              >
                <i class="chevron fa fa-chevron-right"></i>
                <strong>{{ `${policyName} ${startAtYear}` }}</strong>
              </div>
              <div v-if="showCurrentYearBalance">
                <div
                  v-if="currentBalance"
                  class="balance-info"
                >
                  <div class="balance-label">Current balance</div>
                  <div class="balance-value">
                    {{ currentBalance }}
                  </div>
                </div>
                <div class="balance-info">
                  <div class="balance-label">
                    Holiday hours (paid)
                    <i class="hi hi-gift hi-16 text-blue"></i>
                  </div>
                  <div class="balance-value">{{ holidayHours }}</div>
                </div>
                <div class="balance-info">
                  <div class="balance-label">Hours used (paid)</div>
                  <div class="balance-value">{{ hoursUsed }}</div>
                </div>
                <div
                  v-if="pendingApproval"
                  class="balance-info"
                >
                  <div class="balance-label">Other pending approval</div>
                  <div class="balance-value">{{ pendingApproval }}</div>
                </div>
              </div>
            </div>
            <div class="next-year-main-balances middle">
              <div
                v-if="remainingBalance"
                class="balance-info"
              >
                <div class="balance-label">Remaining balance</div>
                <div class="balance-value">
                  <strong>{{ remainingBalance }}</strong>
                </div>
              </div>
            </div>
            <div class="next-year-main-balances end">
              <div
                v-if="showNextYearBalanceChevron"
                class="title cursor-pointer"
                @click="hideNextYearBalance(false)"
              >
                <i class="chevron fa fa-chevron-down"></i>
                <strong>{{ `${policyName} ${stopAtYear}` }}</strong>
              </div>
              <div
                v-else
                class="title cursor-pointer"
                @click="hideNextYearBalance(true)"
              >
                <i class="chevron fa fa-chevron-right"></i>
                <strong>{{ `${policyName} ${stopAtYear}` }}</strong>
              </div>
              <div v-if="showNextYearBalanceChevron">
                <div
                  v-if="currentBalanceNextYear"
                  class="balance-info"
                >
                  <div class="balance-label">Current balance</div>
                  <div class="balance-value">
                    {{ currentBalanceNextYear }}
                  </div>
                </div>
                <div class="balance-info">
                  <div class="balance-label">
                    Holiday hours (paid)
                    <i class="hi hi-gift hi-16 text-blue"></i>
                  </div>
                  <div class="balance-value">{{ holidayHoursNextYear }}</div>
                </div>
                <div class="balance-info">
                  <div class="balance-label">Hours used (paid)</div>
                  <div class="balance-value">{{ hoursUsedNextYear }}</div>
                </div>
                <div
                  v-if="pendingApprovalNextYear"
                  class="balance-info"
                >
                  <div class="balance-label">Other pending approval</div>
                  <div class="balance-value">{{ pendingApprovalNextYear }}</div>
                </div>
                <div
                  v-if="remainingBalanceNextYear"
                  class="balance-info"
                >
                  <div class="balance-label">Projected balance</div>
                  <div class="balance-value">{{ remainingBalanceNextYear }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeOffRequestBalance',
  props: {
    memberAvatar: {
      type: String,
      default: '',
    },
    memberName: {
      type: String,
      default: '',
    },
    policyName: {
      type: String,
      default: '',
    },
    policyType: {
      type: String,
      default: '',
    },
    currentBalance: {
      type: String,
      required: true,
    },
    hoursUsed: {
      type: String,
      required: true,
    },
    remainingBalance: {
      type: String,
      required: true,
    },
    pendingApproval: {
      type: String,
      required: true,
    },
    showNextYearBalance: {
      type: Boolean,
      required: true,
    },
    currentBalanceNextYear: {
      type: String,
      default: '0:00',
    },
    holidayHours: {
      type: String,
      required: true,
    },
    hoursUsedNextYear: {
      type: String,
      default: '0:00',
    },
    remainingBalanceNextYear: {
      type: String,
      default: '0:00',
    },
    pendingApprovalNextYear: {
      type: String,
      default: '0:00',
    },
    holidayHoursNextYear: {
      type: String,
      default: '0:00',
    },
    startAtYear: {
      type: String,
      default: '',
    },
    stopAtYear: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showNextYearBalanceChevron: true,
      showCurrentYearBalance: false,
    };
  },
  computed: {
    hoursUsedMessage() {
      if (!this.policyType) {
        return null;
      }

      return `(${this.policyType})`;
    },
  },
  methods: {
    hideNextYearBalance(value) {
      this.showNextYearBalanceChevron = value;
    },
    hideCurrentYearBalance(value) {
      this.showCurrentYearBalance = value;
    },
  },
};
</script>
